<template lang="pug">
UpsertPage(
  title="Billing settings"
  @save="validateAndSave"
  :pending="isSaving"
  :canSubmit="userIsAdvanced"
  hideCancel
  :saveLabel="chargebeeBtnText"
  )
  .billing-settings
    BillingSettingsFields(
      :billing="billing"
      :validations="$v"
      )
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import UpsertPage from '@v/components/UpsertPage.vue'
import BillingSettingsFields from '@v/settings/application/billing/BillingSettingsFields.vue'
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'BillingSettings',
    validations: {
        billing: {
            SelectedBillingProductCode: {
                required,
            },
        }
    },
    props: {
        userIsAdvanced: {
            type: Boolean,
            required: true,
        },
    },
    components: {
        UpsertPage,
        BillingSettingsFields
    },
    computed: {
        ...mapState('businessUnitBillingData', [
            'billing',
        ]),
        ...mapGetters('businessUnitBillingData', [
            'isPending',
            'isSaving',
            'accontCreatedInBillingSystem',
        ]),
        chargebeeBtnText() {
            return this.accontCreatedInBillingSystem ? 
                'Update customer in Chargebee' : 'Create customer in Chargebee'
        },
    },
    methods: {
        validateAndSave() {
            this.$v.$touch()
            if(!this.$v.$invalid) {
                this.save()
            } 
            else {
                this.$notifyError('There are errors in the form that need to be resolved first.')
            }
        },
        save() {
            this.$emit('save', this.billing)
        },
    },
}
</script>

<style lang="stylus">
.billing-settings
 .briq-form-element, h2
    margin-bottom 24px

.billing-settings
 .form-groups
    margin-bottom: 0

.billing-settings
 .briq-form-element
  li
   margin-left: 20px

</style>